import { useJobStore } from "../../stores/jobStore";
import { api } from "../../api/client";

export function PageAlbum() {
  const { pages, selectedJob, togglePage, categorizeJob, categorizing, categorizeTree } = useJobStore();

  if (!selectedJob) return null;

  const chartCount = pages.filter((p) => p.is_chart).length;

  const handleToggle = (pageNum: number) => {
    togglePage(selectedJob.id, pageNum);
  };

  const handleCategorize = () => {
    categorizeJob(selectedJob.id);
  };

  return (
    <div className="flex flex-col h-full overflow-hidden">
      {/* Toolbar */}
      <div className="flex-shrink-0 flex items-center justify-between px-4 py-2 border-b border-rdp-border bg-rdp-card/40">
        <span className="text-[11px] text-slate-400">
          <span className="font-semibold text-white">{chartCount}</span> نمودار از{" "}
          <span className="font-semibold text-white">{pages.length}</span> صفحه علامت‌گذاری شده
        </span>

        {(selectedJob.status === "INTAKE_COMPLETE" || selectedJob.status === "CATEGORIZED") && (
          <button
            onClick={handleCategorize}
            disabled={categorizing || chartCount === 0}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold
                       bg-blue-600 hover:bg-blue-500 disabled:opacity-40 disabled:cursor-not-allowed
                       text-white transition-colors"
          >
            {categorizing ? (
              <>
                <span className="w-3 h-3 rounded-full border-2 border-white/30 border-t-white animate-spin" />
                Categorizing…
              </>
            ) : (
              "Categorize"
            )}
          </button>
        )}
      </div>

      {/* Categorize result tree */}
      {categorizeTree && (
        <div className="flex-shrink-0 px-4 py-3 border-b border-rdp-border bg-emerald-900/20 text-[11px]">
          <p className="font-semibold text-emerald-400 mb-1.5">Categorized — folder structure:</p>
          {Object.entries(categorizeTree).map(([cat, sessions]) => (
            <div key={cat} className="ml-2 mb-1">
              <span className="text-slate-300 font-medium">📁 {cat}</span>
              {Object.entries(sessions).map(([ses, pnums]) => (
                <div key={ses} className="ml-4 text-slate-500">
                  📂 {ses} <span className="text-slate-600">({pnums.length} pages)</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Album grid */}
      <div className="flex-1 overflow-y-auto p-3">
        {pages.length === 0 ? (
          <div className="flex items-center justify-center h-32 text-slate-600 text-sm">
            در حال اسکن صفحات…
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-2 xl:grid-cols-5 2xl:grid-cols-6">
            {pages.map((page) => (
              <button
                key={page.page_num}
                onClick={() => handleToggle(page.page_num)}
                title={`Page ${page.page_num + 1} — click to toggle`}
                className={`relative group rounded-lg overflow-hidden border-2 transition-all duration-150
                  ${page.is_chart
                    ? "border-emerald-500 shadow-emerald-500/20 shadow-md"
                    : "border-rdp-border hover:border-slate-500"
                  }`}
              >
                <img
                  src={api.jobs.pageThumbnailUrl(page.job_id, page.page_num)}
                  alt={`Page ${page.page_num + 1}`}
                  className="w-full aspect-[3/4] object-cover bg-slate-800"
                  loading="lazy"
                />

                {/* Page number */}
                <div className="absolute bottom-0 left-0 right-0 px-1 py-0.5 bg-black/60 text-[9px] text-slate-400 text-center">
                  {page.page_num + 1}
                </div>

                {/* ✓ / ✗ badge */}
                <div className={`absolute top-1 right-1 w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold shadow
                  ${page.is_chart
                    ? "bg-emerald-500 text-white"
                    : "bg-slate-700 text-slate-400 group-hover:bg-slate-600"
                  }`}
                >
                  {page.is_chart ? "✓" : "✗"}
                </div>

                {/* Category badge for charts */}
                {page.is_chart && page.chart_category && page.chart_category !== "unknown" && (
                  <div className={`absolute top-1 left-1 px-1 py-0.5 rounded text-[8px] font-bold
                    ${page.chart_category === "landing" ? "bg-emerald-600/80 text-white" : "bg-sky-600/80 text-white"}`}
                  >
                    {page.chart_category === "landing" ? "L" : "T"}
                  </div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
